export default __webpack_public_path__ + "static/media/EAST2450.34I-34241_-18457_0.df6373b5.jpg";